import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CompanySearchResultSortCriteria, SearchResultSortActions } from '@warema/shared/models';
import { AppointmentTrackingService } from '@warema/shared/services';
import { WaremaDropdown, WaremaDropdownOption, WaremaInputField } from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-sorting-criteria',
    templateUrl: './sorting-criteria.component.html',
    styleUrls: ['./sorting-criteria.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, WaremaDropdown, WaremaDropdownOption, WaremaInputField],
})
export class SortingCriteriaComponent {
    private readonly _trackingService = inject(AppointmentTrackingService);

    public readonly sortCriteria = input(CompanySearchResultSortCriteria.PrimeStatus);
    public readonly sortCriteriaChanged = output<CompanySearchResultSortCriteria>();

    public searchResultSortActions = SearchResultSortActions.filter(
        x => x.sortType !== CompanySearchResultSortCriteria.InstantOffer,
    );

    public sortChanged(sortCriteria: CompanySearchResultSortCriteria): void {
        this._trackingService.trackFilter(sortCriteria);
        this.sortCriteriaChanged.emit(sortCriteria);
    }
}
